import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";
import { Brand } from "./brand.entity";
import { CommonColumns } from "./common-columns.entity";
import { Question } from "./question.entity";
import { QuestionHeader } from "./question-header.entity";
import { QuestionPage } from "./question-page.entity";
import { ShopToken } from './shop-token.entity';
import { Exclude } from "class-transformer";

@Entity()
export class Shop extends CommonColumns {

  @Column({ length: 100, })
  name: string;

  @Column({ name: 'short_name', length: 5, })
  shortName: string;

  @ManyToOne(() => Brand, brand => brand.shops, { nullable: false, })
  @JoinColumn({ name: 'brand_id', referencedColumnName: 'id', })
  brand: Brand;

  @Column({ name: 'brand_id', })
  brandId: number;

  @Exclude()
  @Column({ length: 512, })
  email: string;

  @Exclude()
  @Column({ name: 'email_cc', length: 2000, default: '', })
  emailCc: string;

  @Exclude()
  @Column({ name: 'email_bcc', length: 2000, default: '', })
  emailBcc: string;

  @OneToMany(() => ShopToken, shopToken => shopToken.shop)
  tokens: ShopToken[];

  @OneToMany(() => QuestionHeader, questionHeader => questionHeader.shop)
  questionHeaders: QuestionHeader[];

  constructor(props: TShop) {
    super();
    Object.assign(this, props);
  }
}

export declare type TShop = Omit<Shop, 'dummy-no-such-field'>;
export interface IShop extends TShop {};
